import React, { useState } from "react";
import { IconButton } from "@mui/material";
import { makeStyles } from "@mui/styles";

import ArrowBackIos from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIos from '@mui/icons-material/ArrowForwardIos';


// Import images
import img1 from "../../../assets/Images/1.png";
import img2 from "../../../assets/Images/2.png";
import img3 from "../../../assets/Images/3.png";
import img4 from "../../../assets/Images/4.png";
import img5 from "../../../assets/Images/5.png";


const images = [img1, img2, img3, img4, img5];

const useStyles = makeStyles({
  root: {
    boxShadow: "0 0 40px rgba(105, 180, 75, 0.05)",
    width: "100%",
  },
  sliderWrapper: {
    width: "50%",
    marginLeft: "400px",
    position: "relative",
    overflow: "hidden",
    marginBottom: "-50px",
  },
  slidesContainer: {
    display: "flex",
    transition: "transform 0.5s ease-in-out",
  },
  slide: {
    minWidth: "100%",
    height: "auto",
    objectFit: "cover",
    borderRadius: "10px",
  },
  arrowButton: {
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
    zIndex: 2,
    backgroundColor: "rgba(255, 255, 255, 0.7)",
    "&:hover": {
      backgroundColor: "#fff",
    },
  },
  leftArrow: {
    left: "5px",
    transform: "scale(1.5)",
    transformOrigin: "center",
    color: "black",
  },
  rightArrow: {
    right: "5px",
    transform: "scale(1.5)",
    transformOrigin: "center",
    color: "black",
  },

  // --------- Media Queries ---------

  '@media (max-width: 319px)': {
    sliderWrapper: {
      width: "90%",
      marginLeft: "auto",
      marginRight: "auto",
      marginBottom: "-30px",
    },
    arrowButton: {
      transform: "translateY(-50%) scale(1.1)",
    },
  },

  '@media (min-width: 320px) and (max-width: 480px)': {
    sliderWrapper: {
      width: "90%",
      marginLeft: "auto",
      marginRight: "auto",
      marginBottom: "-40px",
    },
    arrowButton: {
      transform: "translateY(-50%) scale(1.2)",
    },
  },

  '@media (min-width: 481px) and (max-width: 768px)': {
    sliderWrapper: {
      width: "80%",
      marginLeft: "auto",
      marginRight: "auto",
      marginBottom: "-40px",
    },
    arrowButton: {
      transform: "translateY(-50%) scale(1.3)",
    },
  },

  '@media (min-width: 769px) and (max-width: 1024px)': {
    sliderWrapper: {
      width: "70%",
      marginLeft: "auto",
      marginRight: "auto",
      marginBottom: "-45px",
    },
  },

  '@media (min-width: 1025px) and (max-width: 1440px)': {
    sliderWrapper: {
      width: "60%",
      marginLeft: "auto",
      marginRight: "auto",
      marginBottom: "-50px",
    },
  },

  '@media (min-width: 1441px)': {
    sliderWrapper: {
      width: "50%",
      marginLeft: "auto",
      marginRight: "auto",
      marginBottom: "-50px",
    },
  },
});


const Work = () => {
  const classes = useStyles();
  const [currentIndex, setCurrentIndex] = useState(0);

  const goToNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const goToPrev = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  return (
    <div className={classes.root}>
      <div className={classes.sliderWrapper}>
        <div
          className={classes.slidesContainer}
          style={{
            transform: `translateX(-${currentIndex * 100}%)`,
          }}
        >
          {images.map((img, index) => (
            <img
              key={index}
              src={img}
              alt={`Slide ${index + 1}`}
              className={classes.slide}
            />
          ))}
        </div>
        <IconButton
          className={`${classes.arrowButton} ${classes.leftArrow}`}
          onClick={goToPrev}
        >
          <ArrowBackIos />
        </IconButton>
        <IconButton
          className={`${classes.arrowButton} ${classes.rightArrow}`}
          onClick={goToNext}
        >
          <ArrowForwardIos />
        </IconButton>
      </div>
    </div>
  );
};

export default Work;